module.exports = __webpack_public_path__ + "static/media/spiral-tower.f5095a0e.md";